import gsap from 'gsap';

export default class Heading extends HTMLElement {
    static CALL_EVENT = 'callHeading';
    static INTERVALLE = 3;
    static ILLU_INTERVALLE = 0.5;

    constructor() {
        super();

        /* Binding */
        this.onScrollCall = this.onScrollCall.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.onUpdateIllustration = this.onUpdateIllustration.bind(this);

        /* UI */
        this.$words = Array.from(this.querySelectorAll('[data-word]'));
        this.$illus = Array.from(this.querySelectorAll('[data-illustration]'));

        /* Data */
        this.uid = this.dataset.uid;
        this.activeIndex = this.$words.findIndex(($word) => $word.classList.contains('is-active'));
        this.hasIllustrations = this.dataset.illustrations ? true : false;

        this.activeIlluIndex = 0;
    }

    // =============================================================================
    // Lifecycle methods
    // =============================================================================
    connectedCallback() {
        this.bindEvents();
    }

    disconnectedCallback() {
        this.unbindEvents();
        this.delayedCall?.kill();

        if (this.hasIllustrations) {
            this.delayedIllusCall?.kill();
        }
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        window.addEventListener(`${Heading.CALL_EVENT}${this.uid}`, this.onScrollCall);
    }

    unbindEvents() {
        window.removeEventListener(`${Heading.CALL_EVENT}${this.uid}`, this.onScrollCall);
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onScrollCall(event) {
        // Handle scroll enter/leave events for autoplay
        const { way } = event.detail;

        switch (way) {
            case 'enter':
                this.play();
                break;
            case 'leave':
                this.pause();
                break;
        }
    }

    onUpdate() {
        // If there is only one word, stop the animation
        if (this.$words.length === 1) {
            this.delayedCall?.kill();
            return;
        }

        // Update the active word
        this.$words[this.activeIndex].classList.remove('is-active');

        // Get a random index but exclude the current active index
        let randomIndex = Math.floor(Math.random() * this.$words.length);
        while (randomIndex === this.activeIndex) {
            randomIndex = Math.floor(Math.random() * this.$words.length);
        }

        this.activeIndex = randomIndex;

        this.$words[this.activeIndex].classList.add('is-active');

        // Restart the animation
        this.delayedCall.restart(true);
    }

    onUpdateIllustration() {
        // Update the active word
        this.$illus[this.activeIlluIndex].classList.remove('is-active');

        this.activeIlluIndex = (this.activeIlluIndex + 1) % this.$illus.length;

        this.$illus[this.activeIlluIndex].classList.add('is-active');

        // Restart the animation
        this.delayedIllusCall.restart(true);
    }

    // =============================================================================
    // Methods
    // =============================================================================
    play() {
        if (this.isPlaying) return;
        this.delayedCall = gsap.delayedCall(Heading.INTERVALLE, this.onUpdate, null);

        if (this.hasIllustrations) {
            this.delayedIllusCall = gsap.delayedCall(
                Heading.ILLU_INTERVALLE,
                this.onUpdateIllustration,
                null
            );
        }

        this.isPlaying = true;
    }

    pause() {
        if (!this.isPlaying) return;
        this.delayedCall?.kill();

        if (this.hasIllustrations) {
            this.delayedIllusCall?.kill();
        }

        this.isPlaying = false;
    }
}
